import React from "react";
import "./LoadingSkeleton.css";

function LoadingSkeleton() {
    return <div className="loading-skeleton" />;
}

export default LoadingSkeleton;
